import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { RootState } from "@/store";
import { Toast } from "vant";
import { FORMAT_DATE_SMALL, isFinish } from "@/utils/common/date";
import { isBegin } from "@/utils/common/date";
import { handlePaginationData, queryRequest } from "@/utils/request";
import {
  queryK1PriceActivity,
  queryK1ActivitySku,
  searchK1ActivitySku
} from "@/graphql/promotion.gql";

export interface IK1PromotionState {
  promotion: any;
  promotionProducts: any[];
  activityCode: string;
}

@Module({ name: "K1PromotionDetailModule", namespaced: true })
export default class K1PromotionDetailModule
  extends VuexModule<IK1PromotionState, RootState>
  implements IK1PromotionState {
  // 活动
  public promotion = {};
  // 活动商品
  public promotionProducts = [];
  // 活动编号
  public activityCode: string = "";
  // 添加购物车途中
  public addingCart: boolean = false;

  @Mutation
  saveAddingCartMutation(data: boolean) {
    this.addingCart = data || false;
  }

  @Mutation
  saveActivityCodeMutation(data: string = "") {
    this.activityCode = data || "";
  }

  @Mutation
  savePromotionMutation(data = {}) {
    this.promotion = data;
  }
  @Mutation
  savePromotionProductsMutation(data = []) {
    this.promotionProducts = data || [];
  }

  // 清空页面数据
  @Action
  clearPageCacheDataAction() {
    const { commit } = this.context;
    commit("savePromotionMutation");
    commit("savePromotionProductsMutation");
    commit("saveActivityCodeMutation");
  }

  // 查询页面数据
  @Action
  async initDataAction() {
    const { state, commit } = this.context;
    const { data } = handlePaginationData(
      await queryRequest({
        query: queryK1PriceActivity,
        variables: {
          input: { activityCode: state.activityCode, activityType: "K1" },
          pageInput: { pageNum: 1 }
        }
      })
    );
    commit("savePromotionMutation", data[0]);
  }

  @Action
  async queryK1ActivitySkuAction() {
    const { state, commit } = this.context;
    const data = await queryRequest({
      query: searchK1ActivitySku,
      variables: { priceActivityCode: state.activityCode }
    });
    commit("savePromotionProductsMutation", data);
  }

  // 验证活动是否开始
  @Action
  verifyBeginAction() {
    const {
      state: { promotion }
    } = this.context;
    if (!isBegin(promotion.countDownStart, FORMAT_DATE_SMALL)) {
      Toast("活动还未开始，请耐心等待");
      return false;
    }
    if (isFinish(promotion.countDownEnd, FORMAT_DATE_SMALL)) {
      Toast("活动已结束，感谢参与");
      return false;
    }
    return true;
  }
}
